import React from 'react'

const ResponseSendImageQuestionary = () => {
  return (
    <svg
      width="71"
      height="70"
      viewBox="0 0 71 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5041 32.8828C13.7263 32.8828 12.9918 33.1853 12.4444 33.7398L0.856996 45.3056C0.302469 45.8602 0 46.5875 0 47.3653C0 48.1431 0.302469 48.8777 0.856996 49.425C1.41152 49.9795 2.14609 50.282 2.92387 50.282C3.70165 50.282 4.44342 49.9795 4.99074 49.425L16.5638 37.8519C17.1183 37.2974 17.4208 36.5701 17.4208 35.7923C17.4208 35.0145 17.1183 34.2799 16.5638 33.7326C16.0165 33.1853 15.2819 32.8828 14.5041 32.8828Z"
        fill="black"
      />
      <path
        d="M69.0061 2.67901C67.8826 1.00103 66.0246 0 64.0369 0C63.252 0 62.4814 0.158436 61.7324 0.468107L18.4217 18.2706C16.0956 19.2284 14.6337 21.4753 14.7057 24.0031C14.7777 26.5165 16.3692 28.677 18.7674 29.4979L34.9783 35.0288L40.5236 51.2397C41.3662 53.7099 43.5915 55.3014 46.2057 55.3014C48.683 55.3014 50.8075 53.8755 51.7509 51.5854L69.5606 8.26749C70.3384 6.38786 70.1295 4.34259 69.0061 2.67901ZM46.04 49.3673L40.0339 31.8025C39.7458 30.9455 39.0688 30.2685 38.2118 29.9805L20.647 23.9815C20.5822 23.9599 20.5462 23.9455 20.5318 23.8302C20.539 23.715 20.5678 23.7006 20.6326 23.6718L63.9289 5.87654C63.9937 5.85494 64.0225 5.84774 64.0225 5.84774C64.0513 5.84774 64.1018 5.86934 64.145 5.93416C64.1522 5.94136 64.1522 5.94856 64.1594 5.95576C64.1738 5.97016 64.1738 5.98457 64.1738 5.98457C64.1738 5.98457 64.1738 6.01337 64.1522 6.07099C64.1522 6.07819 64.145 6.08539 64.145 6.09259L46.3353 49.3745C46.3065 49.4465 46.2921 49.4681 46.1913 49.4681C46.076 49.4753 46.0616 49.4321 46.04 49.3673Z"
        fill="#BE9137"
      />
      <path
        d="M32.1698 53.451L20.6039 65.0168C20.0422 65.5713 19.7325 66.3059 19.7325 67.0981C19.7325 67.8759 20.035 68.6104 20.5895 69.1506C21.1441 69.6979 21.8714 70.0004 22.6564 70.0004C23.4414 70.0004 24.176 69.6979 24.7233 69.1434L36.2963 57.5703C37.4342 56.4325 37.4342 54.5816 36.2963 53.4438C35.1585 52.3131 33.3076 52.3131 32.1698 53.451Z"
        fill="black"
      />
      <path
        d="M21.8714 51.0665C22.6564 51.0665 23.391 50.7641 23.9383 50.2095L32.998 41.1427C33.5525 40.5881 33.855 39.8608 33.855 39.083C33.855 38.3052 33.5525 37.5706 32.998 37.0233C31.8601 35.8855 30.0093 35.8855 28.8714 37.0233L19.8046 46.0902C19.25 46.6447 18.9476 47.3721 18.9476 48.1499C18.9476 48.9276 19.25 49.6622 19.8046 50.2095C20.3591 50.7641 21.0937 51.0665 21.8714 51.0665Z"
        fill="black"
      />
    </svg>
  )
}

export default ResponseSendImageQuestionary
